import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Icon from '@material-ui/core/Icon';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';


class DropdownMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectOpen: false,
    };
  }


  get placeholderActive() {
    const { value, placeholder } = this.props;
    return (placeholder || placeholder === 0) && (!value && value !== 0);
  }

  getPlaceholder() {
    const { placeholder } = this.props;
    if (!this.placeholderActive) {
      return {};
    }
    return {
      renderValue: () => <span className="dropdown-placeholder">{placeholder}</span>,
    };
  }

  handleChange = (event) => {
    this.props.onChange(null, null, event.target.value);
    this.setState({ [event.target.name]: event.target.value });
  };

  renderContent() {
    const { classes, disabled, error, onFocus } = this.props;
    const { selectOpen } = this.state;

    const menuItems = this.props.items.map((i) => {
      const style = this.props.value === i.value ? { ...this.props.selectedMenuItemStyle, ...this.props.menuItemStyle } : this.props.menuItemStyle;
      return (
        <MenuItem style={style} className={this.props.menuItem} key={i.value} value={i.value}>{i.name}</MenuItem>
      );
    });

    return (
      <FormControl error={error} className={`dropdown-menu ${classes.formControl} ${this.props.formControl}`} style={this.props.formControlStyle}>
        {this.props.label && <InputLabel shrink={this.placeholderActive || undefined} htmlFor="dropdown-menu">{this.props.label}</InputLabel>}
        <Select
          onFocus={onFocus}
          onChange={this.handleChange}
          value={(this.props.value === null || this.props.value === undefined) ? '' : this.props.value}
          displayEmpty
          inputProps={{
            name: 'dd',
          }}
          classes={{
            selectMenu: this.props.selectMenu,
          }}
          multiple={this.props.multiple}
          disabled={disabled}
          open={selectOpen}
          onOpen={() => this.setState({ selectOpen: true })}
          onClose={() => this.setState({ selectOpen: false })}
          {...this.getPlaceholder()}
        >
          {menuItems}
        </Select>
      </FormControl>
    );
  }

  render() {
    const { iconLeft, value } = this.props;
    if (iconLeft) {
      return (
        <div className="dropdown-with-left-icon">
          <Icon onClick={() => this.setState({ selectOpen: true })} color={value || value === 0 ? 'primary' : 'secondary'}>{iconLeft}</Icon>
          {this.renderContent()}
        </div>
      );
    }
    return this.renderContent();
  }
}

DropdownMenu.propTypes = {
  items: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  iconLeft: PropTypes.any,
  onFocus: PropTypes.func,
  classes: PropTypes.object,
  menuItemStyle: PropTypes.object,
  selectedMenuItemStyle: PropTypes.object,
  selectMenu: PropTypes.string,
  formControl: PropTypes.string,
  menuItem: PropTypes.string,
  formControlStyle: PropTypes.object,
  value: PropTypes.any,
  label: PropTypes.string,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

DropdownMenu.defaultProps = {
  iconLeft: null,
  value: '',
  classes: null,
  menuItemStyle: {},
  selectedMenuItemStyle: {},
  selectMenu: '',
  formControl: '',
  menuItem: '',
  formControlStyle: {},
  label: '',
  multiple: false,
  disabled: false,
  error: false,
  onFocus: () => {},
};

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
});

export default withStyles(styles)(DropdownMenu);
